import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-prompt'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'custom_prompt_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => ({
            name: 'custom_prompt_index',
            params: to.params,
          }),
        },
        {
          path: 'list',
          name: 'custom_prompt_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
